module.exports = __webpack_public_path__ + "media/images/emoticons/punch-c700d9eaa1d15427493bd4530f798203.gif";